<template>
  <naj-box :title="local.regentForm.title">
    <v-row>
      <v-col
        cols="12"
        lg="2"
      >
        <naj-input
          :type-id="formFieldType.selectbox"
          :label="local.regentForm.minorTypeId"
          :value.sync="formModel.minorTypeId"
          :disabled="viewMode"
          :items="minorCases"
          item-text="name"
          item-value="id"
          validates="required"
        ></naj-input>
      </v-col>
      <v-col
        cols="12"
        lg="3"
      >
        <naj-input
          :type-id="formFieldType.selectbox"
          :label="local.regentForm.relativeTypeId"
          :value.sync="formModel.relativeTypeId"
          :disabled="viewMode"
          :items="relatives"
          item-text="name"
          item-value="id"
          validates="required"
        ></naj-input>
      </v-col>
      <v-col
        cols="12"
        lg="2"
      >
        <naj-input
          :type-id="formFieldType.number"
          :label="local.regentForm.regencyNumber"
          :value.sync="formModel.regencyNumber"
          :validates="`required|long|max:14|isValid:${local.regentForm.invalidNumber},${isNumberValid}|isVerified:${true || formModel.isVerified || formModel.isManualDeed}`"
          :disabled="viewMode"
          @input="changeVerification(false)"
        ></naj-input>
      </v-col>
      <v-col
        cols="12"
        lg="1"
      >
        <naj-input
          class="align-checkbox-with-input"
          :type-id="formFieldType.checkbox"
          :label="local.regentForm.isManualDeed"
          :value.sync="formModel.isManualDeed"
          :disabled="viewMode"
        ></naj-input>
      </v-col>
      <v-col
        v-if="false && !formModel.isVerified && !formModel.isManualDeed"
        cols="12"
        lg="1"
      >
        <naj-button
          square
          inputs-alignment
          :loading="isChecking"
          :disabled="!isCheckingValidityValid"
          @click="validateRegencyNumber"
        >
          {{ local.common.check }}
        </naj-button>
      </v-col>
    </v-row>
  </naj-box>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const { mapActions: mapSysActions } = createNamespacedHelpers('SystemModule');
const { mapState: mapLUTState, mapActions: mapLUTActions } = createNamespacedHelpers(
  'LookupsModule'
);

export default {
  inject: ['$validator'],
  props: ['formModel', 'regentSocialId', 'viewMode'],
  data() {
    return { isChecking: false };
  },
  computed: {
    ...mapLUTState(['minorCases', 'relatives', 'instrumentSources']),
    isCheckingValidityValid() {
      return this.formModel.regencyNumber && this.regentSocialId && this.formModel.socialId;
    },
    isNumberValid() {
      return this.formModel.regencyNumber !== 0;
    },
  },
  created() {
    this.getMinorCases();
    this.getRelatives();
    this.getInstrumentSources();
  },
  methods: {
    ...mapLUTActions(['getMinorCases', 'getRelatives', 'getInstrumentSources']),
    ...mapSysActions(['validateRegency']),
    validateRegencyNumber() {
      this.isChecking = true;
      this.validateRegency({
        regencyNumber: this.formModel.regencyNumber,
        guardianSocialId: this.regentSocialId,
        minorSocialId: this.formModel.socialId,
      })
        .then(() => {
          this.toaster.success(this.local.common.verificationSucceeded, 2);
          this.changeVerification(true);
        })
        .catch(() => {
          this.toaster.error(`${this.local.regentForm.title} غير صحيحة`);
          this.changeVerification(false);
        })
        .finally(() => (this.isChecking = false));
    },
    changeVerification(isVerified) {
      this.$set(this.formModel, 'isVerified', isVerified);
    },
  },
};
</script>
